import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/guest-replies`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}` } });

export const grApi = {
  settings: () => axios.get(`${API}/settings`, hdr()).then((r) => r.data),
  saveSettings: (body) => axios.put(`${API}/settings`, body, hdr()).then((r) => r.data),
  poll: () => axios.post(`${API}/poll`, null, hdr()).then((r) => r.data),
  train: () => axios.post(`${API}/train`, null, hdr()).then((r) => r.data),
  questions: (status = "pending") => axios.get(`${API}/questions`, { params: { status }, ...hdr() }).then((r) => r.data),
  redraft: (id) => axios.post(`${API}/questions/${encodeURIComponent(id)}/redraft`, null, hdr()).then((r) => r.data),
  send: (id, body) => axios.post(`${API}/questions/${encodeURIComponent(id)}/send`, body, hdr()).then((r) => r.data),
  skip: (id) => axios.post(`${API}/questions/${encodeURIComponent(id)}/skip`, null, hdr()).then((r) => r.data),
  faq: () => axios.get(`${API}/faq`, hdr()).then((r) => r.data),
  faqCreate: (body) => axios.post(`${API}/faq`, body, hdr()).then((r) => r.data),
  faqUpdate: (id, body) => axios.put(`${API}/faq/${id}`, body, hdr()).then((r) => r.data),
  faqDelete: (id) => axios.delete(`${API}/faq/${id}`, hdr()).then((r) => r.data),
  compose: (body) => axios.post(`${API}/compose`, body, hdr()).then((r) => r.data),
  faqSuggest: (id) => axios.post(`${API}/faq/${id}/suggest`, null, hdr()).then((r) => r.data),
};
